export default "/_next/static/images/product--tours-legacy-6b408d067af90ee5d8ce887edd0fefea.svg";